{
  "version": "v4.2.5",
  "name": "CreatePairAndAddLiquidity",
  "bytecodeTemplate": "0101030001004029{0}7a7a{2}a2{3}0da3{4}0da3{0}{2}{3}{4}100c{1}0106{1}{3}{4}44cc1700{0}7a{3}{5}a3{4}{6}a3{0}{5}{6}0f0d1600010e18",
  "fieldsSig": {
    "names": [
      "payer",
      "factory",
      "alphAmount",
      "token0Id",
      "token1Id",
      "amount0",
      "amount1"
    ],
    "types": [
      "Address",
      "TokenPairFactory",
      "U256",
      "ByteVec",
      "ByteVec",
      "U256",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}